<template>
  <w-flex class="justify-end">
    <template v-if="max > 100">
      <div class="box ml1 z-pagination-text">
      <w-select v-if="path" label="Lompat" label-position="left" :items="pages" class="box" v-model="page" />
      </div>
    </template>
    <template v-else>
      <inertia-link v-for="(link, idx) in links" :key="idx" text md class="ml1 box z-pagination-text" :href="link.url" v-html="link.label" preserve-state></inertia-link>
    </template>
  </w-flex>
</template>

<script>
export default {
  name: 'z-pagination',
  props: {
    from: {
      type: Number,
      default: 1
    },
    to: {
      type: Number,
      default: 10
    },
    max: {
      type: Number,
      default: 10
    },
    current: {
      type: Number,
      default: 1
    },
    showGoto: {
      type: Boolean,
      default: true
    },
    perPage: {
      type: Number,
      default: 10
    },
    path: String,
    links: [Object, Array]
  },
  data() {
    return {
      page: this.current,
    }
  },
  computed: {
    hasToolBarButton() {
      return !!this.$slots.buttons
    },
    pages() {
      const res = [...Array(this.max)].map((_, i) => { return { label: (i+1), value: (i+1) } });
      return res
    }
  },
  methods: {
    // loadpg () {
    //   this.$emit('loading',true);
    //   this.$inertia.visit(this.path + '?page='+this.page +'&per_page=' + this.perPage, { preserveScroll: true })
    // }
  },
  watch: {
    current:  function  (val) {
      this.page = val
    },
    page: function (val) {
      this.$emit('pageChanged', val)
    },
    perPage:  function  (val, oldval) {
      // if(val != oldval) {
      //   console.log(val, oldval)
      //   // this.loadpg()
      // }
    },
  }
}
</script>

<style>
.table-bar-search-bottom {
    padding: 0px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
}
</style>